// ---------------------------------------------------------------------------
// Brown & Associates — Landing page configuration
// Edit these values in one place. Contact details are intentionally left as
// clearly labeled placeholders — do NOT invent real contact information.
// ---------------------------------------------------------------------------

export const SITE = {
  businessName: "Brown & Associates, LLC",
  shortName: "Brown & Associates",
  location: "Manchester, New Hampshire",
  serviceArea: "New Hampshire & remote clients",

  // The scheduling destination for every primary call-to-action.
  calendlyUrl: "https://calendly.com/joede1123",

  // Intended production domain — NOT connected/published yet.
  domain: "bookkeepingcheckup.com",

  // ----- CONTACT PLACEHOLDERS (replace with verified details) -----
  contact: {
    emailPlaceholder: "[ Add business email address ]",
    phonePlaceholder: "[ Add business telephone number ]",
  },
};

// ----- GOOGLE ADS CONVERSION TRACKING (placeholders) -----
// Replace these once you have your real Google Ads conversion values.
// Until real IDs are set, no analytics/conversion pixels are loaded.
export const GOOGLE_ADS = {
  // e.g. "AW-123456789"
  CONVERSION_ID: "AW-CONVERSION_ID_PLACEHOLDER",
  // e.g. "AbC-D_efG-h12_34-567"
  CONVERSION_LABEL: "CONVERSION_LABEL_PLACEHOLDER",
  CONVERSION_EVENT_NAME: "schedule_consultation_click",
};
